import AsyncDropdown from "components/Dropdown/AsyncDropdown";
import { useState, useCallback, useEffect } from "react";

const BlacklistDropdown = ({
    marketplaceId,
    blackListName,
    blackListLabel,
    getMarketplaceBlacklists,
    blacklist,
    setBlacklist
}: {
    marketplaceId: number,
    blackListName: string,
    blackListLabel: string,
    getMarketplaceBlacklists: any,
    blacklist: any[],
    setBlacklist: (value: any) => void
}) => {
    const LIMIT = 10;
    const [inputValue, setInputValue] = useState("");
    const [options, setOptions] = useState<Array<{ label: string, value: number }>>([]);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const loadOptions = useCallback(async (input: string, offset: number) => {
        setIsLoading(true);
        try {
            const { data } = await getMarketplaceBlacklists({
                variables: {
                    pagination: {
                        marketplaceId: marketplaceId,
                        [blackListName]: {
                            search: input ? parseInt(input) : undefined,
                            limit: LIMIT,
                            offset: offset
                        }
                    }
                }
            });

            const newOptions = data?.getMarketplaceBlacklists[blackListName].map((v: number) => ({
                label: String(v),
                value: v
            }));

            setHasMore(true);
            return newOptions;
        } catch (error) {
            console.error("Error loading options:", error);
            return [];
        } finally {
            setIsLoading(false);
        }
    }, [getMarketplaceBlacklists, marketplaceId, blackListName]);

    const handleInputChange = (newValue: string) => {
        setInputValue(newValue);
    };

    const handleMenuScrollToBottom = async () => {
        if (!hasMore || isLoading) return;

        const newOptions = await loadOptions(inputValue, options.length);
        setOptions([...options, ...newOptions]);
    };

    const handleChange = (selectedOptions: Array<{ label: string, value: number }>) => {
        setBlacklist(selectedOptions.map(option => option.value));
        setInputValue("");
        loadOptions("", 0).then((initialOptions) => {
            setOptions(initialOptions);
        });
    };

    useEffect(() => {
        loadOptions("", 0).then((initialOptions) => {
            setOptions(initialOptions);
        });
    }, [loadOptions]);

    const blacklistValue = blacklist.map((shop) => ({ label: String(shop), value: shop }));

    return (
        <AsyncDropdown
            defaultOptions={options}
            loadOptions={async (input: string) => {
                const initialOptions = await loadOptions(input, 0);
                setOptions(initialOptions);
                return initialOptions;
            }}
            onInputChange={handleInputChange}
            placeholder="Search"
            label={blackListLabel}
            value={blacklistValue}
            isMulti
            className="input-blacklist"
            onChange={handleChange}
            onMenuScrollToBottom={handleMenuScrollToBottom}
            isLoading={isLoading}
        />
    );
};

export default BlacklistDropdown;